import ProductsCompare from './ProductsCompare'

export { ProductsCompare }

export default ProductsCompare
